import React from "react";
import { Typography, Box, Stack } from "@mui/joy";

const steps = [
  {
    number: "01",
    title: "Choose your issue",
    description: "Browse active federal bills with plain-language summaries. See who sponsored it, what it changes, and where it stands today."
  },
  {
    number: "02",
    title: "Customize your message",
    description: "Find your representative by address, then use our email template as a starting point. Edit it to reflect your own voice and experience."
  },
  {
    number: "03",
    title: "Send your email",
    description: "Copy your message and paste it into your representative's official contact form. Most congressional offices respond within 30 days."
  }
];

const HowTo = () => {
  return (
    <Box
      sx={{
        maxWidth: "1200px",
        mx: "auto",
        width: "100%",
        px: { xs: "1.25rem", md: "2rem" },
        pt: { xs: "3rem", md: "2rem" },
        pb: { xs: "4rem", md: "6rem" },
      }}
    >
      <Stack spacing={1} sx={{ mb: { xs: "3rem", md: "4rem" } }}>
        <Typography
          component="p"
          sx={{
            fontSize: "16px",
            fontWeight: 600,
            color: "var(--ce-dark-eyebrow)",
            textTransform: "uppercase",
            letterSpacing: "0.05em",
          }}
        >
          How it works
        </Typography>
        <Typography
          level="h2"
          sx={{
            color: "white",
            fontSize: { xs: "2rem", md: "3rem" },
            fontWeight: 700,
            lineHeight: 1.2,
          }}
        >
          Three steps. Real impact.
        </Typography>
      </Stack>

      <Stack direction={{ xs: "column", md: "row" }} spacing={{ xs: 0, md: 0 }}>
        {steps.map((step, index) => (
          <Box
            key={index}
            sx={{
              flex: 1,
              pl: { md: index > 0 ? "2rem" : 0 },
              pr: { md: index < steps.length - 1 ? "2rem" : 0 },
              borderRight: {
                md: index < steps.length - 1 ? "1px solid rgba(255,255,255,0.12)" : "none",
              },
              mb: { xs: index < steps.length - 1 ? "3rem" : 0, md: 0 },
            }}
          >
            <Typography
              component="p"
              sx={{
                fontSize: "64px",
                fontWeight: 700,
                lineHeight: 1,
                color: "var(--ce-dark-secondary)",
                mb: "1rem",
              }}
            >
              {step.number}
            </Typography>

            <Box
              sx={{
                width: "48px",
                height: "1px",
                backgroundColor: "rgba(255,255,255,0.3)",
                mb: "1rem",
              }}
            />

            <Typography
              sx={{
                color: "white",
                fontWeight: 600,
                fontSize: "1.5rem",
                lineHeight: 1.25,
                mb: "1rem",
              }}
            >
              {step.title}
            </Typography>

            <Typography
              sx={{
                color: "white",
                lineHeight: 1.65,
                fontSize: "1.125rem",
              }}
            >
              {step.description}
            </Typography>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default HowTo;
